import {combineReducers} from 'redux'
import cptList from './cptAssignmentsList/reducer'
import createAssignedTeamReducer from './assignedTeamList/reducer'

export default () => {
    return combineReducers({
        teamList: createAssignedTeamReducer,
        cptLists: cptList
    })
}


// WEBPACK FOOTER //
// ./web/js/userProfile/reducer.js